import {useSessionStorage} from '@github-ui/use-safe-storage/session-storage'
import {useCallback, useMemo} from 'react'
import {expandedFindingsStorageKey} from './storage-keys'

const normalizeExpandedFindingIds = (value: unknown): string[] => {
  if (!Array.isArray(value)) return []

  const ids = new Set<string>()
  for (const item of value) {
    if (typeof item === 'string' && item.length > 0) {
      ids.add(item)
    }
  }
  return [...ids]
}

export const useExpandedFindings = (pullRequestBasePath: string) => {
  const [expandedFindingIds, setExpandedFindingIds] = useSessionStorage<string[]>(
    expandedFindingsStorageKey(pullRequestBasePath),
    [],
  )
  const expandedFindingIdSet = useMemo(
    () => new Set(normalizeExpandedFindingIds(expandedFindingIds)),
    [expandedFindingIds],
  )
  const handleToggleFindingExpanded = useCallback(
    (findingId: string) => {
      setExpandedFindingIds(prev => {
        const next = new Set(normalizeExpandedFindingIds(prev))
        if (next.has(findingId)) next.delete(findingId)
        else next.add(findingId)
        return [...next]
      })
    },
    [setExpandedFindingIds],
  )

  return {expandedFindingIdSet, handleToggleFindingExpanded}
}
